import type { DefaultQueryError } from '@ahm/api-wrappers-core';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import {
  billableWeightFn,
  type BillableWeightRequestBody,
  type BillableWeightResponse,
} from '@/api/services/billable-weight-fn';

export const useBillableWeight = (
  opts?: UseMutationOptions<
    BillableWeightResponse,
    DefaultQueryError,
    BillableWeightRequestBody
  >
) =>
  useMutation<
    BillableWeightResponse,
    DefaultQueryError,
    BillableWeightRequestBody
  >({
    mutationFn: billableWeightFn,
    ...opts,
  });
